import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import Header from '@/components/Header';
import { Sidebar } from '@/components/Navigation';
import { CortinaLogo, NiicoLogo } from '@/components/Logos';
import Copyright from '@/components/Copyright';

const Logo = ({ isNiico = false }) => {
  if (isNiico) return <NiicoLogo />;
  return <CortinaLogo />;
};

Logo.propTypes = {
  isNiico: PropTypes.bool,
};

export default function Home() {
  const isNiico = process.env.NEXT_PUBLIC_IS_NIICO === 'true';
  return (
    <Container sx={{ height: '100%' }} maxWidth="xl">
      <Header title="Home" />
      <Sidebar />
      <Logo isNiico={isNiico} />
      <Copyright />
    </Container>
  );
}
